import { AnyAction } from 'redux';
import produce from 'immer';
import {
  GET_VISITOR_SIMPLE_AUTH_REQUEST,
  GET_VISITOR_SIMPLE_AUTH_SUCCESS,
  GET_VISITOR_SIMPLE_AUTH_FAILURE,
  GET_VISITOR_SIMPLE_AUTH_INITIAL,
} from '../../actions';

export type GetSimpleAuthResult = {
  isLoading: boolean;
  isLoaded: boolean;
  result: number;
  message: string | null;
  visitorId: string | null;
  reservationCount: number;
  historyId: number;
};

export type SimpleAuthType = {
  getSimpleAuthResult: GetSimpleAuthResult;
};

const initialState: SimpleAuthType = {
  getSimpleAuthResult: {
    isLoading: false,
    isLoaded: false,
    result: 0,
    message: null,
    visitorId: null,
    reservationCount: 0,
    historyId: 0,
  },
};

const simpleAuthReducer = (state = initialState, action: AnyAction): SimpleAuthType => {
  return produce(state, (draft) => {
    const dataState = draft;
    switch (action.type) {
      case GET_VISITOR_SIMPLE_AUTH_REQUEST:
        dataState.getSimpleAuthResult.isLoading = true;
        dataState.getSimpleAuthResult.isLoaded = false;
        dataState.getSimpleAuthResult.result = initialState.getSimpleAuthResult.result;
        dataState.getSimpleAuthResult.message = initialState.getSimpleAuthResult.message;
        dataState.getSimpleAuthResult.visitorId = initialState.getSimpleAuthResult.visitorId;
        dataState.getSimpleAuthResult.reservationCount = initialState.getSimpleAuthResult.reservationCount;
        dataState.getSimpleAuthResult.historyId = initialState.getSimpleAuthResult.historyId;
        break;
      case GET_VISITOR_SIMPLE_AUTH_SUCCESS:
        dataState.getSimpleAuthResult.isLoading = false;
        dataState.getSimpleAuthResult.isLoaded = true;
        dataState.getSimpleAuthResult.result = action.res.result;
        dataState.getSimpleAuthResult.message = action.res.error_message;
        dataState.getSimpleAuthResult.visitorId = action.res.visitor_id;
        dataState.getSimpleAuthResult.reservationCount = action.res.reservation_count;
        dataState.getSimpleAuthResult.historyId = action.res.history_id;
        break;
      case GET_VISITOR_SIMPLE_AUTH_FAILURE:
        dataState.getSimpleAuthResult.isLoading = false;
        dataState.getSimpleAuthResult.isLoaded = false;
        dataState.getSimpleAuthResult.result = 1;
        dataState.getSimpleAuthResult.message = null;
        dataState.getSimpleAuthResult.visitorId = null;
        dataState.getSimpleAuthResult.reservationCount = 0;
        dataState.getSimpleAuthResult.historyId = 0;
        break;
      case GET_VISITOR_SIMPLE_AUTH_INITIAL:
        dataState.getSimpleAuthResult = initialState.getSimpleAuthResult;
        break;
      default:
        break;
    }
  });
};

export default simpleAuthReducer;
